const PREFIX = 'UI_';

export const SET_ACTIVE_GROUP_ID = `${PREFIX}SET_ACTIVE_GROUP_ID`;
export const UNSET_ACTIVE_GROUP_ID = `${PREFIX}UNSET_ACTIVE_GROUP_ID`;
